<template>
  <v-dialog
    v-model="coronaDialog.show"
    max-width="500"
  >
    <v-card>
      <v-card-title class="primary white--text">
        <h3 class="headline mb-0">
          {{ $t('texts.corona.alertText' )}}
        </h3>
        <v-spacer/>
        <v-btn text small fab @click="coronaDialog.show = false">
          <v-icon color="white">close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text v-html="$t('texts.corona.text')" class="pb-0" />
      <v-divider/>
      <v-card-text class="pt-3">
        <p>{{ $t('texts.corona.usefulInformation') }}</p>
        <ul>
          <li>
            <a :href="`https://www.bag.admin.ch/bag/${$i18n.locale}/home.html`" target="_blank">
              {{ $t('texts.corona.bag') }}
            </a>
          </li>
          <li>
            <a href="http://www.hsgr.ch/de/pub/graubuenden/organisation/coronavirus.htm" target="_blank">
              {{ $t('texts.corona.hotelleriesuisseGrisons') }}
            </a>
          </li>
          <li>
            <a href="https://www.hotelleriesuisse.ch/it/pub/services/coronavirus.htm" target="_blank">
              {{ $t('texts.corona.hotelleriesuisseTicino') }}
            </a>
          </li>
        </ul>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  data() {
    return {
      coronaDialog: {
        show: false,
      },
    };
  },
  mounted() {
    this.$eventBus.$on('show-corona-dialog', () => {
      this.coronaDialog.show = true;
    });
  },
};
</script>
